import React from "react";
import { BrazilGeoMap } from "../Echarts";

import {
  MapSessionContainer,
  MapSessionCardContainer,
  MapSessionCard,
  MapSessionCardDescriptionContent,
  MapSessionCardDescriptionHeader,
  MapSessionCardDescriptionContainer,
  MapContainerComponent,
  LoadingContainer,
  ProgressCiculeLoading,
} from "./styles";
import { useAxios } from "../../../../../hooks/useAxios";

export function MapSession() {
  let uri = "/porcentagem_obitos_por_uf/";
  const { loading, error, response } = useAxios({
    method: "GET",
    url: uri,
    headers: {
      accept: "*/*",
    },
  });

  React.useEffect(() => {
    if (response) {
      console.log(response);
    }
  }, [response]);

  return (
    <>
      <MapSessionContainer>
        <MapSessionCardContainer>
          <MapSessionCardDescriptionContainer>
            <MapSessionCardDescriptionContent>
              <MapSessionCardDescriptionHeader>
                Mapa de percentual de óbitos por covid-19 entre profissionais da
                saúde no <strong>Brasil</strong>{" "}
              </MapSessionCardDescriptionHeader>
            </MapSessionCardDescriptionContent>
          </MapSessionCardDescriptionContainer>
          <MapSessionCard>
            {loading && (
              <MapContainerComponent>
                <LoadingContainer>
                  carregando dados do mapa...
                  <ProgressCiculeLoading size={20} color={"inherit"} />
                </LoadingContainer>
              </MapContainerComponent>
            )}

            {response && response.dados.length > 0 && (
              <>
                <MapContainerComponent>

                  <BrazilGeoMap data={response} />

                </MapContainerComponent>
              </>
            )}
            {(error || response?.dados.length === 0) && (
              <MapContainerComponent>
                Não vai ser possível mostrar o mapa. {error}
              </MapContainerComponent>
            )}
          </MapSessionCard>
        </MapSessionCardContainer>
      </MapSessionContainer>
    </>
  );
}
